import * as baseUrl from "../shared/base_url";
const _base_url = baseUrl.base_url;
export default {
  admin: {
    get_user_list: _base_url + "/Admin/GetUserList", //get
    get_role_list: _base_url + "/Admin/GetRoleList", //get
    get_role_root_list: _base_url + "/Admin/GetRoleRootList", //get
    get_privilege_list: _base_url + "/Admin/GetPrivilegeList", //get
    get_role_own_privilege_list: _base_url + "/Admin/GetRoleOwnPrivilegeList/", //get /Admin/GetRoleOwnPrivilegeList/{roleId}
    get_role_all_privilege_list: _base_url + "/Admin/GetRoleAllPrivilegeList/", //get /Admin/GetRoleAllPrivilegeList/{roleId}
    get_role_children_list: _base_url + "/Admin/GetRoleChildren/", //get /Admin​/GetRoleChildren​/{roleId}
    get_role_parents_list: _base_url + "/Admin/GetRoleParents/", //get /Admin/GetRoleParents/{roleId}
    get_role_users_list: _base_url + "/Admin/GetRoleUsers/", //get /Admin/GetRoleUsers/{roleId}
    get_user_roles_list: _base_url + "/Admin/GetUserRoles/", //get /Admin/GetUserRoles/{specUserId}
    add_role_child: _base_url + "/Admin/AddRoleChild", //post /Admin/AddRoleChild
    remove_role_child: _base_url + "/Admin/RemoveRoleChild", //post /Admin/AddRoleChild
    update_role: _base_url + "/Admin/UpdateRole", //post  update role
    add_role: _base_url + "/Admin/AddRole", //post  add role
    get_user_privilege_list: _base_url + "/Admin/GetUserPrivileges/", // get /Admin/GetUserPrivileges/{specUserId}
    block_user: _base_url + "/Admin/BlockUser", //post block users
    active_user: _base_url + "/Admin/ActiveUser", //post active users
    remove_role: _base_url + "/Admin/RemoveRole", //post remove role
    add_role_own_privileges: _base_url + "/Admin/AddRoleOwnPrivileges", //post add_role_own_privileges
    remove_role_own_privileges: _base_url + "/Admin/RemoveRoleOwnPrivileges", //post remove_role_own_privileges
    update_privileges: _base_url + "/Admin/UpdatePrivilege", //post UpdatePrivilege
    add_role_user: _base_url + "/Admin/AddRoleUser", //post /Admin/AddRoleUser
    remove_role_user: _base_url + "/Admin/RemoveRoleUser", //post /Admin/RemoveRoleUser
    get_notify_types: _base_url + "/Admin/GetNotifyTypes/", //get get_notify_types
    get_notify_users: _base_url + "/Admin/GetNotifyUsers", //get get_notify_types
    add_notify_type: _base_url + "/Admin/AddNotifyType", //post add_notify_type
    update_notify_type: _base_url + "/Admin/UpdateNotifyType", //post update_notify_type
    remove_notify_type: _base_url + "/Admin/DeleteNotifyType", //post remove_notify_type
    add_notify_users: _base_url + "/Admin/AddNotifyUser", //post add_notify_users
    remove_notify_user: _base_url + "/Admin/DeleteNotifyUser", //post remove_notify_user

    add_user: _base_url + "/Admin/AddUser",
    update_user: _base_url + "/Admin/UpdateUser",
    reset_pwd: _base_url + "/Admin/ResetPassword",
    CleanRoleOwnPrivileges: _base_url + "/Admin/CleanRoleOwnPrivileges",
  },
  axInterface: {
    axInterface_invoke: _base_url + "/AxInterface/Invoke", //get /AxInterface/Invoke
    pickand_invoke: _base_url + "/axinterface/pickandinvoke" //get company=070&tableName=secp_sei_custtable&accountNum=100021168,
  },
  email: {
    email_send: _base_url + "/Email​/Send",
    get_email: _base_url + "/Email/GetEmailNotifies", //get
    add_notify: _base_url + "/email/AddNotify", //post category,idx,notify_type,subject,content
    cancel_notify: _base_url + "/email/CancelNotify" //post idx:xxx,notify_type:xxx
  },
  updated: {
    file_upload: _base_url + "/Upload/Files/upload/files", //post
    img_upload: _base_url + "/Upload/Images/upload/images", //post
    excel_upload: _base_url + "/Upload/Excel" //get
  },
  plant: {
    base_data: _base_url + "/data/base_data",
  },
  common: {
    get_setting: _base_url + "/common/get_setting/"
  },
  user: {
    login: _base_url + "/User/Login/",
    get_userinfo: _base_url + "/user/get_userinfo/",
    profile: _base_url + "/user/profile",
    reset_pwd: _base_url + "/user/ResetPassword",
    login_uri: _base_url + "/user/LoginUri",
  },
  pub: {
    get_pub_token: _base_url + "/Pub/get_pub_token/", //get /Pub/get_pub_token/{idx}/{pub_pwd}
    get_pub_data: _base_url + "/Pub/get_pub_data/", //get /Pub/get_pub_data/{idx}/{contentType}
    save_pub_data: _base_url + "/Pub/save_pub_data/" //post /Pub/save_pub_data/{idx}/{contentType}
  },
  log: {
    logs: _base_url + "/Log/Logs",
    sys_logs: _base_url + "/Log/SysLogs"
  },
  language: _base_url + "/language/langsetting",
  file: {
    upload: _base_url + "/upload/filestoazure",
    delete: _base_url + "/upload/DeleteFromAzure",
    downLoad: _base_url + "/upload/downloadfromazure",
    update: _base_url + "/upload/UpdateDescription",
    upload_file: _base_url + "/upload/files", ///普通文件上传
    file_list: _base_url + "/upload/filelist", ///获取上传的普通文件
    upload_delete: _base_url + "/upload/delete", ///删除上传的普通文件
  }
};
